import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useRoute } from "vue-router";
import AppPageHeader from "@/components/app/AppPageHeader.vue";
import ReminderForm from "@/components/reminders/ReminderForm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReminderEditFormView',
  setup(__props) {

const route = useRoute()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppPageHeader, null, {
      default: _withCtx(() => [
        _createTextVNode("Edit reminder")
      ]),
      _: 1
    }),
    _createVNode(ReminderForm, {
      "item-id": _unref(route).params.id
    }, null, 8, ["item-id"])
  ], 64))
}
}

})